//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'dialogQusetion',
  components: {},
  props: {
    DialogQuestion: {
      type: Object,
      default: function _default() {}
    },
    relatedDialogQuestion: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {},
  data: function data() {
    return {};
  },
  methods: {
    showRelatedQuestionModal: function showRelatedQuestionModal(question) {
      this.$emit('showRelatedQuestionModal', question);
    }
  }
};